import type {TikTokAppStruct} from '@cohort/shared/apps/tiktok';
import {TikTokAppSpec} from '@cohort/shared/apps/tiktok';
import {SvgAppIcon} from '@cohort/shared-frontend/common/AppIcons';
import type {App} from '@cohort/wallet/apps';
import type {ContentMedia} from '@cohort/wallet/apps/Media';
import {TikTokPostContentMedia} from '@cohort/wallet/apps/tiktok/medias/post/Media';
import {TikTokCommentTiktokTriggerIntegration} from '@cohort/wallet/apps/tiktok/triggers/commentTiktok/TriggerIntegration';
import {TikTokFollowTriggerIntegration} from '@cohort/wallet/apps/tiktok/triggers/follow/TriggerIntegration';
import {TikTokKeywordInBioTriggerIntegration} from '@cohort/wallet/apps/tiktok/triggers/keywordInBio/TriggerIntegration';
import {TikTokKeywordInDescriptionTriggerIntegration} from '@cohort/wallet/apps/tiktok/triggers/keywordInDescription/TriggerIntegration';
import {TikTokLikeTiktokTriggerIntegration} from '@cohort/wallet/apps/tiktok/triggers/likeTiktok/TriggerIntegration';
import {TikTokRepostTiktokTriggerIntegration} from '@cohort/wallet/apps/tiktok/triggers/repostTiktok/TriggerIntegration';
import type {TriggerIntegration} from '@cohort/wallet/apps/TriggerIntegration';

const TikTokApp: App<TikTokAppStruct> = {
  spec: TikTokAppSpec,
  perkIntegrations: [],
  triggerIntegrations: [
    TikTokFollowTriggerIntegration,
    TikTokLikeTiktokTriggerIntegration,
    TikTokCommentTiktokTriggerIntegration,
    TikTokRepostTiktokTriggerIntegration,
    TikTokKeywordInBioTriggerIntegration,
    TikTokKeywordInDescriptionTriggerIntegration,
  ] as Array<TriggerIntegration>,
  medias: [TikTokPostContentMedia] as Array<ContentMedia>,
  logo: <SvgAppIcon name="tiktok" height={40} width={40} />,
};

export default TikTokApp;
